"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BEACH_SURFACE_TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = require("@lt/localization");

var _HotelCardFact = _interopRequireDefault(require("./HotelCardFact"));

var _BeachSand = _interopRequireDefault(require("../../icons-react/hotel-facts/BeachSand"));

var _BeachPebble = _interopRequireDefault(require("../../icons-react/hotel-facts/BeachPebble"));

var _BeachSandPebble = _interopRequireDefault(require("../../icons-react/hotel-facts/BeachSandPebble"));

var _BeachPlatform = _interopRequireDefault(require("../../icons-react/hotel-facts/BeachPlatform"));

var BEACH_SURFACE_TYPES = {
  SAND: {
    icon: /*#__PURE__*/_react["default"].createElement(_BeachSand["default"], null),
    label: _localization.i18n.t('hotelcard.facts.surface.sand')
  },
  PEBBLE: {
    icon: /*#__PURE__*/_react["default"].createElement(_BeachPebble["default"], null),
    label: _localization.i18n.t('hotelcard.facts.surface.pebble')
  },
  'SAND+PEBBLE': {
    icon: /*#__PURE__*/_react["default"].createElement(_BeachSandPebble["default"], null),
    label: _localization.i18n.t('hotelcard.facts.surface.sand_pebble')
  },
  PLATFORM: {
    icon: /*#__PURE__*/_react["default"].createElement(_BeachPlatform["default"], null),
    label: _localization.i18n.t('hotelcard.facts.surface.platform')
  }
};
exports.BEACH_SURFACE_TYPES = BEACH_SURFACE_TYPES;

var TOOLTIP = _localization.i18n.t('hotelcard.facts.surface.tooltip');

var HotelBeachSurface = function HotelBeachSurface(_ref) {
  var value = _ref.value,
      className = _ref.className;
  var surfaceType = BEACH_SURFACE_TYPES[value && value.toUpperCase()];

  if (!surfaceType) {
    return null;
  }

  var icon = surfaceType.icon,
      label = surfaceType.label;
  return /*#__PURE__*/_react["default"].createElement(_HotelCardFact["default"], {
    className: className,
    label: label,
    tooltip: TOOLTIP,
    icon: icon
  });
};

HotelBeachSurface.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string
};
HotelBeachSurface.defaultProps = {
  className: ''
};

var _default = /*#__PURE__*/_react["default"].memo(HotelBeachSurface);

exports["default"] = _default;